import { render, staticRenderFns } from "./ReportDowngrader.vue?vue&type=template&id=8bede1be&lang=html&"
import script from "./ReportDowngrader.vue?vue&type=script&lang=js&"
export * from "./ReportDowngrader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports